import { createI18n } from 'vue-i18n';
import nb from '@/i18n/nb';
import nn from '@/i18n/nn';
import en from '@/i18n/en';

export enum Locale {
  NB_NO = 'nb-NO',
  NN_NO = 'nn-NO',
  EN_GB = 'en-GB',
}

export const locales = `${Locale}`;

export const i18n = createI18n({
  useScope: 'global',
  legacy: false,
  globalInjection: true,
  locale: import.meta.env.VITE_DEFAULT_LANG,
  messages: {
    [Locale.NB_NO]: nb,
    [Locale.NN_NO]: nn,
    [Locale.EN_GB]: en,
  },
});

export default i18n;
